<template>
  <CCard>
    <CCardHeader>Scale Pods Schedule</CCardHeader>
    <CCardBody>
      <CDataTable
        :loading="loading"
        :items="scaleSchedules"
        :fields="scaleScheduleFields"
      >
        <template #scale_up_at="{ item }">
          <td>{{ formatDateTime(item.scale_up_at, 'dd MMM yyyy HH:mm') }}</td>
        </template>
        <template #scale_down_at="{ item }">
          <td>{{ formatDateTime(item.scale_down_at, 'dd MMM yyyy HH:mm') }}</td>
        </template>
        <template #is_active="{ item }">
          <td>
            <b :class="item.is_active ? 'text-success' : 'text-danger'">
              {{ item.is_active ? 'Active' : 'Inactive' }}
            </b>
          </td>
        </template>

        <template #actions="{ item }">
          <td>
            <CButton
              v-if="item.is_active"
              size="sm"
              color="danger"
              variant="outline"
              @click="deactivateSchedule(item.id)"
              :disabled="deactivatingId === item.id"
            >
              <CIcon v-if="deactivatingId === item.id" name="cil-spinner" />
              {{
                deactivatingId === item.id ? 'Deactivating...' : 'Deactivate'
              }}
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import format from 'date-fns/format';
export default {
  name: 'PNScalePodSchedule',
  data() {
    return {
      scaleSchedules: [],
      deactivatingId: null,
      loading: false,
      scaleScheduleFields: [
        { key: 'scale_up_at', label: 'Scale Up Time' },
        { key: 'scale_down_at', label: 'Scale Down Time' },
        { key: 'is_active', label: 'Status' },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    getScaleSchedules() {
      this.loading = true;
      this.$store.dispatch('getScalePodsSchedules').then((res) => {
        this.scaleSchedules = res.data;
        this.loading = false;
      });
    },

    formatDateTime(date) {
      return format(new Date(date), 'dd MMM yyyy HH:mm');
    },

    async deactivateSchedule(id) {
      this.deactivatingId = id;
      try {
        await this.$store.dispatch('deactivateScalePodsLog', id);
        // Refresh the data after successful deactivation
        this.getScaleSchedules();
      } catch (error) {
        console.error('Error deactivating schedule:', error);
      } finally {
        this.deactivatingId = null;
      }
    },
  },
  mounted() {
    this.getScaleSchedules();
  },
};
</script>
